export const GUIDED_TOUR_PENDING_KEY = 'effiez-guided-tour-pending';
export const GUIDED_TOUR_COMPLETED_KEY = 'effiez-guided-tour-completed';

function getScopedKey(baseKey, userId) {
  return `${baseKey}:${userId || 'anonymous'}`;
}

export function queueGuidedTourLaunch(userId) {
  if (typeof window === 'undefined') return;
  if (window.localStorage.getItem(getScopedKey(GUIDED_TOUR_COMPLETED_KEY, userId)) === 'true') return;
  window.sessionStorage.setItem(getScopedKey(GUIDED_TOUR_PENDING_KEY, userId), '1');
}

export function consumeGuidedTourLaunch(userId) {
  if (typeof window === 'undefined') return false;
  const pendingKey = getScopedKey(GUIDED_TOUR_PENDING_KEY, userId);
  const shouldOpen = window.sessionStorage.getItem(pendingKey) === '1';
  if (shouldOpen) {
    window.sessionStorage.removeItem(pendingKey);
  }
  return shouldOpen;
}

export function markGuidedTourCompleted(userId) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(getScopedKey(GUIDED_TOUR_COMPLETED_KEY, userId), 'true');
  window.sessionStorage.removeItem(getScopedKey(GUIDED_TOUR_PENDING_KEY, userId));
}